// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ui6CV","right":"styles_right__3DpOv"};